/**
 * Stable invoice pay URL for the current browser environment (local vs production).
 */
export function buildPublicInvoicePayUrl(paymentAccessToken) {
  if (!paymentAccessToken) return null;
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  if (!base) return null;
  return `${base.replace(/\/$/, '')}/pay/i/${paymentAccessToken}`;
}
